import React, { useState } from "react";
import { Box, Paper, Typography } from "@mui/material";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import FormCrearCiclo from "./components/Form/FormCrearCiclo";
import TableCycles from "./components/TableCycles";

export default function CrearCiclo() {
  const [refreshFlag, setRefreshFlag] = useState(false);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ py: 3 }}>
        <Box sx={{ bgcolor: "#183b50", color: "#fff", p: 3, borderRadius: "12px 12px 0 0" }}>
          <Typography sx={{ color: "inherit", fontWeight: 700, fontSize: "1.15rem" }}>
            Creación de ciclos
          </Typography>
          <Typography sx={{ color: "#d7e5ee", fontSize: ".8rem" }}>
            Registro de ingresos e historial de resultados por comercio
          </Typography>
        </Box>
        <Paper sx={{ p: { xs: 2, md: 3 }, borderRadius: "0 0 12px 12px", mb: 3 }}>
          <FormCrearCiclo onSubmit={() => setRefreshFlag((value) => !value)} />
        </Paper>
        <Paper sx={{ p: { xs: 2, md: 3 }, borderRadius: 3 }}>
          <TableCycles refreshFlag={refreshFlag} />
        </Paper>
      </Box>
    </DashboardLayout>
  );
}
